import { render, staticRenderFns } from "./RemesasTabContent.vue?vue&type=template&id=6861a9aa"
import script from "./RemesasTabContent.vue?vue&type=script&lang=js"
export * from "./RemesasTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports